import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d53102e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "col-md-12" }
const _hoisted_2 = { class: "card card-container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  id: "profile-img",
  src: "//ssl.gstatic.com/accounts/ui/avatar_2x.png",
  class: "profile-img-card"
}, null, -1))
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "form-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_form = _resolveComponent("q-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_q_form, {
        onSubmit: _ctx.handleRegister,
        class: "q-gutter-md"
      }, {
        default: _withCtx(() => [
          (!_ctx.successful)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_q_input, {
                  filled: "",
                  modelValue: _ctx.name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event)),
                  label: _ctx.t('maintoolbar.login'),
                  hint: _ctx.t('login.enterlogin'),
                  "lazy-rules": "",
                  rules: [ val => val && val.length > 0 || _ctx.t('login.loginisrequired'),
                    val => val.length >=3 || _ctx.t('register.mustbeatleast3ch'),
                    val => val.length <20 || _ctx.t('register.mustbemaximum20'),
                    val => val.match('^[a-zA-Z0-9_.-]*$') || _ctx.t('register.onlyenglishletters')
          ]
                }, {
                  prepend: _withCtx(() => [
                    _createVNode(_component_q_icon, { name: "person" })
                  ]),
                  _: 1
                }, 8, ["modelValue", "label", "hint", "rules"]),
                _createVNode(_component_q_input, {
                  filled: "",
                  modelValue: _ctx.email,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.email) = $event)),
                  label: _ctx.t('profile.email'),
                  hint: _ctx.t('profile.enteremail'),
                  "lazy-rules": "",
                  rules: [ val => val && val.length > 0 ||  _ctx.t('profile.emailisrequired'),
                    val => val.length <50 ||  _ctx.t('profile.mustbemaximum50ch'),
                    this.isValidEmail]
                }, {
                  prepend: _withCtx(() => [
                    _createVNode(_component_q_icon, { name: "email" })
                  ]),
                  _: 1
                }, 8, ["modelValue", "label", "hint", "rules"]),
                _createVNode(_component_q_input, {
                  filled: "",
                  modelValue: _ctx.password,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.password) = $event)),
                  label: _ctx.t('login.password'),
                  hint: _ctx.t('login.enterpassword'),
                  type: _ctx.passwordFieldType,
                  "lazy-rules": "",
                  rules: [ val => val && val.length > 0 || _ctx.t('login.passwordrequired'),
                     val => val.length >=6 || _ctx.t('profile.mustbeatleast6ch'),
                    val => val.length < 40 || _ctx.t('profile.mustbemaximum40'),]
                }, {
                  prepend: _withCtx(() => [
                    _createVNode(_component_q_icon, { name: "lock" })
                  ]),
                  append: _withCtx(() => [
                    _createVNode(_component_q_icon, {
                      name: _ctx.visibilityIcon,
                      onClick: _ctx.switchVisibility,
                      class: "cursor-pointer"
                    }, null, 8, ["name", "onClick"])
                  ]),
                  _: 1
                }, 8, ["modelValue", "label", "hint", "type", "rules"]),
                _createVNode(_component_q_input, {
                  filled: "",
                  modelValue: _ctx.confpassword,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.confpassword) = $event)),
                  label: _ctx.t('profile.confirmationpassword'),
                  hint: _ctx.t('profile.enterconfirmationpassword'),
                  type: _ctx.passwordFieldType,
                  "lazy-rules": "",
                  rules: [ val => val && val.length > 0 || _ctx.t('login.passwordrequired'),
                     val => val.length >=6 || _ctx.t('profile.mustbeatleast6ch'),
                    val => val.length < 40 || _ctx.t('profile.mustbemaximum40'),
                    _ctx.diffPassword]
                }, {
                  prepend: _withCtx(() => [
                    _createVNode(_component_q_icon, { name: "lock" })
                  ]),
                  append: _withCtx(() => [
                    _createVNode(_component_q_icon, {
                      name: _ctx.visibilityIcon,
                      onClick: _ctx.switchVisibility,
                      class: "cursor-pointer"
                    }, null, 8, ["name", "onClick"])
                  ]),
                  _: 1
                }, 8, ["modelValue", "label", "hint", "type", "rules"]),
                _createVNode(_component_q_input, {
                  filled: "",
                  modelValue: _ctx.userpassword,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.userpassword) = $event)),
                  label: _ctx.t('profile.userpassword'),
                  hint: _ctx.t('profile.enteruserpassword'),
                  type: _ctx.passwordFieldType,
                  "lazy-rules": "",
                  rules: [ val => val && val.length > 0 || _ctx.t('login.passwordrequired'),
                     val => val.length >=6 || _ctx.t('profile.mustbeatleast6ch'),
                    val => val.length < 40 || _ctx.t('profile.mustbemaximum40'),]
                }, {
                  prepend: _withCtx(() => [
                    _createVNode(_component_q_icon, { name: "lock" })
                  ]),
                  append: _withCtx(() => [
                    _createVNode(_component_q_icon, {
                      name: _ctx.visibilityIcon,
                      onClick: _ctx.switchVisibility,
                      class: "cursor-pointer"
                    }, null, 8, ["name", "onClick"])
                  ]),
                  _: 1
                }, 8, ["modelValue", "label", "hint", "type", "rules"]),
                _createVNode(_component_q_input, {
                  filled: "",
                  modelValue: _ctx.confuserpassword,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.confuserpassword) = $event)),
                  label: _ctx.t('profile.confirmationuserpassword'),
                  hint: _ctx.t('profile.enterconfirmationuserpassword'),
                  type: _ctx.passwordFieldType,
                  "lazy-rules": "",
                  rules: [ val => val && val.length > 0 || _ctx.t('login.passwordrequired'),
                     val => val.length >=6 || _ctx.t('profile.mustbeatleast6ch'),
                    val => val.length < 40 || _ctx.t('profile.mustbemaximum40'),
                    _ctx.diffUserPassword]
                }, {
                  prepend: _withCtx(() => [
                    _createVNode(_component_q_icon, { name: "lock" })
                  ]),
                  append: _withCtx(() => [
                    _createVNode(_component_q_icon, {
                      name: _ctx.visibilityIcon,
                      onClick: _ctx.switchVisibility,
                      class: "cursor-pointer"
                    }, null, 8, ["name", "onClick"])
                  ]),
                  _: 1
                }, 8, ["modelValue", "label", "hint", "type", "rules"]),
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_q_btn, {
                    label: _ctx.t('maintoolbar.signup'),
                    class: "full-width",
                    size: "lg",
                    type: "submit",
                    color: "primary",
                    loading: _ctx.loading,
                    disable: _ctx.loading
                  }, null, 8, ["label", "loading", "disable"])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["onSubmit"]),
      (_ctx.message)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["alert", _ctx.successful ? 'alert-success' : 'alert-danger'])
          }, _toDisplayString(_ctx.message), 3))
        : _createCommentVNode("", true)
    ])
  ]))
}